import _get from 'lodash/get';

function formatNumber(number) {
  if (!number || !Number.isInteger(number)) return '0';
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function validateDulicate(list = []) {
  if (list.length < 2) return true;
  for (let i = 0; i < list.length; i++) {
    for (let j = i + 1; j < list.length; j++) {
      if (_get(list, `${i}.coupon_code`, '').toLowerCase() === _get(list, `${j}.coupon_code`, '').toLowerCase())
        return false;
    }
  }
  return true;
}

export { formatNumber, validateDulicate };
